import { Component } from '@angular/core';
import { AppService } from '../../services/app.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-whats-new-modal',
	templateUrl: './whats-new-modal.html'
})

export class WhatsNewModalComponent {
	public version: any;

	constructor(private _appService: AppService,
				public dialogRef: MatDialogRef<WhatsNewModalComponent>) {
		this.version = this._appService.version;
	}

	close() {
		this.dialogRef.close();
	}
}
